import { render, staticRenderFns } from "./IconMore.vue?vue&type=template&id=2c687b39&scoped=true"
import script from "./IconMore.vue?vue&type=script&lang=js"
export * from "./IconMore.vue?vue&type=script&lang=js"
import style0 from "./IconMore.vue?vue&type=style&index=0&id=2c687b39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c687b39",
  null
  
)

export default component.exports